import { render } from "./PurchaseOrderView.vue?vue&type=template&id=f3c8bd42&ts=true"
import script from "./PurchaseOrderView.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__